<div class="checkpoint-lane-container">
  @for (item of data; track $index; let last = $last) {
    <div class="checkpoint-lane-row">
      <div class="checkpoint-lane-left">
        <ng-container
          *ngTemplateOutlet="leftTemplate; context: { $implicit: item }"
        ></ng-container>
      </div>
      <div class="checkpoint-lane-line" [class.last]="last"></div>
      <div class="checkpoint-lane-right">
        <ng-container
          *ngTemplateOutlet="rightTemplate; context: { $implicit: item }"
        ></ng-container>
      </div>
    </div>
  }
</div>
